import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 * Returns the in-code form definition for the asset/checkpoint creation and edit form.
 *
 * Previously stored as seed data in the `form_definitions` table (id: `asset_form`).
 * Moved to code so the definition can be updated without schema changes or migrations.
 *
 * A `translate` function is accepted so labels and placeholders are resolved at
 * runtime (e.g. via TranslationService) rather than being baked in as static strings.
 *
 * Note: The `interaction_type_ids` field that existed in the database definition has been
 * intentionally omitted — interaction type selection is handled separately by the form picker
 * UI in CheckPointFormComponent, not via Formly.
 */
export function getCheckPointFormFields(translate: (key: string) => string): FormlyFieldConfig[] {
  return [
    {
      key: 'name',
      type: 'input',
      wrappers: ['inline-edit'],
      props: {
        label: translate('checkpoint.formDefinition.nameLabel'),
        placeholder: translate('checkpoint.formDefinition.namePlaceholder'),
        required: true,
        inlineEditVariant: 'title',
      },
    },
    {
      key: 'description',
      type: 'textarea',
      wrappers: ['inline-edit'],
      props: {
        label: translate('checkpoint.formDefinition.descriptionLabel'),
        placeholder: translate('checkpoint.formDefinition.descriptionPlaceholder'),
        rows: 4,
      },
    },
  ];
}
